import { render, staticRenderFns } from "./A22.vue?vue&type=template&id=27e56444&"
import script from "./A22.vue?vue&type=script&lang=js&"
export * from "./A22.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "A22.vue"
export default component.exports